import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Label, Row } from "reactstrap";
import { postCancelOrder } from "../../../../CommonUrl";
import { postDataWithToken } from "../../../../Utils/restUtils";

const CancelOrderForm = ({ setisOpenAdd, order_id }) => {
    const { register, handleSubmit, control, formState: { errors } } = useForm();

    const boxStyle = {
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        padding: "10px",
        borderRadius: "8px",
        backgroundColor: "#ffffff",
    };

    const onSubmit = async (data) => {
        const postData = {
            comments:data?.description,
            order_id: order_id,
        };
        const response = await postDataWithToken(postCancelOrder, postData);
        if (response?.status === 200) {
            if (response?.data?.status === true) {
                toast.success(response?.data?.message);
                setisOpenAdd(false);
            } else {
                toast.error(response?.data?.message);
            }
        }
    };

    return (
        <div className="container mt-4">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div style={boxStyle}>
                            <Row className="col-md-12" style={{marginLeft:'0.3%'}}>
                                <Label className="form-label blue">Reason</Label>
                                <Controller
                                    name="description"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                            <textarea
                                                className="form-control"
                                                {...field}
                                                rows="3"
                                                maxLength={300}
                                                {...register('description')}
                                            />
                                            <p className="text-danger">{errors.description?.message}</p>
                                        </>

                                    )}
                                />
                            </Row>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col text-center">
                        <button type="submit" className="pay-all">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default CancelOrderForm;
